import React from 'react';
import PropTypes from 'prop-types';
import FormattedText from '../../../components/01_atoms/FormattedText';

import styles from './index.module.scss';

const BBText = ({ text }) => (
  <div className={`bb ${styles['bb-text']}`}>
    <FormattedText text={text} className="container" />
  </div>
);

BBText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default BBText;
